<!-- Footer -->
<footer class="hh-footer">
  <!-- Main Footer -->
  <div class="hh-footer__main">
    <span *ngIf="isAnyListingFromMaine()">
      <img
        _ngcontent-jqb-c216=""
        height="40"
        class="ml-2"
        src="https://propmix.io/wp-content/uploads/2023/10/Maine_IDX_Blue.jpg"
      /><br />
      <p>
        Listing data is derived in whole or in part from the Maine IDX and is for consumers' personal, noncommercial use
        only. Dimensions are approximate and not guaranteed. All data should be independently verified. © 2023 Maine
        Real Estate Information System, Inc. All Rights Reserved.
      </p>
    </span>
    <div class="hh-footer__content">
      <!-- Logo -->
      <a class="hh-footer__logo" href="https://homehunt.com/" aria-label="Home">
        <svg
          aria-hidden="true"
          aria-labelledby="hh-footer-logo"
          focusable="false"
          role="img"
          height="72"
          viewBox="0 0 242.83 148.78"
          xmlns="http://www.w3.org/2000/svg"
        >
          <title id="hh-footer-logo">HomeHunt</title>
          <path
            style="fill: none"
            d="M82.2 64.7h15.72V43.3H82.2ZM94 52.8a1.23 1.23 0 1 1 .14 1.73A1.24 1.24 0 0 1 94 52.8Z"
          />
          <path
            style="fill: none"
            d="M130.5 45.68A40.54 40.54 0 1 0 90 86.22a40.53 40.53 0 0 0 40.5-40.54Zm-21.93-8.08v30h-7.88l-9.17 8.9c4.91.15 8.63.89 8.63 1.78s-4.68 1.81-10.45 1.81-10.45-.81-10.45-1.81 3.7-1.62 8.58-1.78l-9.16-8.9H72v-30h-6l6-5.78v-6.95h5.34v1.77l13-12.59 24.18 23.55Z"
          />
          <path
            style="fill: hsl(var(--green-500_hsl)); opacity: 0.27"
            d="M87.83 76.53c-4.88.16-8.58.9-8.58 1.78s4.68 1.81 10.45 1.81 10.45-.81 10.45-1.81-3.72-1.63-8.63-1.78l-1.84 1.8Z"
          />
          <path
            style="fill: hsl(var(--blue-700_hsl))"
            d="M187.61 95.65h20.28v53.13h14.67V95.65h20.28V82.13h-55.23v13.52zM60.78 119.63V86.3a46.78 46.78 0 0 1-5-4.17H41.7v26.37h-27V82.13H0v66.65h14.66V122h27v26.76H85v-.21s-10-.48-16.6-7.1c-5-4.95-7.62-12.14-7.62-21.82ZM168.22 123.17 137 82.13h-13.8a46.42 46.42 0 0 1-5.2 4.34v32.69a38.15 38.15 0 0 1-2 13 24.57 24.57 0 0 1-5.76 9.23 23.57 23.57 0 0 1-9.1 5.53 33.24 33.24 0 0 1-6.54 1.49v.34H138v-42.34l32.27 42.37h12.47V82.13h-14.52ZM77.33 26.64v-1.77H72v7l-6 5.73h6v30h6.68l9.16 8.9H91.53l9.17-8.9h7.88v-30h6l-24.3-23.55ZM97.92 64.7H82.2V43.3h15.72ZM87.83 76.53l1.85 1.8 1.84-1.8H89.7c-.62 0-1.26-.01-1.87 0Z"
          />
          <path
            style="fill: hsl(var(--green-500_hsl))"
            d="M95.92 54.39a1.23 1.23 0 1 0-1.74.14 1.22 1.22 0 0 0 1.74-.14ZM207.58 71.28v-20h31.17v-5.87h-31.17v-19.5h34.85v-5.88h-41.29v57.12h41.7v-5.87h-35.26z"
          />
          <path
            style="fill: hsl(var(--green-500_hsl))"
            d="M102.77 116.87V90.53c19.75-5.71 32.42-24 32.42-44.34v-.25C135.19 21.31 116.94 0 89.76 0S44.08 21.56 44.08 46.19v.26c0 20.89 13.13 39.39 33.71 44.52v25.48q0 7.13 3.31 10.71t9.18 3.6q5.88 0 9.18-3.47t3.31-10.42ZM90 86.22a40.54 40.54 0 1 1 40.5-40.54A40.54 40.54 0 0 1 90 86.22ZM131.39 77.22h6.28V53.48a49.75 49.75 0 0 1-6.28 18.24ZM158.73 51.27 137.92 20.1h-6.53v.32c3.23 5.52 6.28 10.61 6.28 10.61l20.81 30.52h.33L179.62 31v46.22h6.45V20.1h-6.53Z"
          />
          <path
            style="fill: hsl(var(--green-500_hsl))"
            d="M6.46 51.52h33v25.7h6.45v-9.1a51.16 51.16 0 0 1-4.8-21.67v-.26a50.71 50.71 0 0 1 4.8-21.66V20.1h-6.48v25.38h-33V20.1H0v57.12h6.46Z"
          />
        </svg>
      </a>
      <!-- / End Logo -->

      <!-- Text Content -->
      <h2>Continental Real Estate Group, Inc.</h2>

      <p class="hh-paragraph hh-body-heading">We are a full-service real estate company ready to serve&nbsp;you.</p>
      {{ companyInfo?.phone?.displayLabel }}
      <p class="hh-paragraph">You can also call or email us&nbsp;directly.</p>
      <p class="hh-paragraph">
        Call us at
        <a
          class="hh-footer__main-link"
          [href]="'tel:' + companyInfo?.phone?.value"
          rel="noopener"
          [attr.aria-label]="companyInfo?.phone?.value"
          >{{ companyInfo?.phone?.displayText }}<span class="hh-visually-hidden">, dials a phone number. </span></a
        ><br />
        Email us at
        <a class="hh-footer__main-link" [href]="'mailto:' + companyInfo?.contactEmail" rel="noopener"
          >{{ companyInfo?.contactEmail }}<span class="hh-visually-hidden">, opens an email window.</span></a
        >
      </p>
      <!-- / End Text Content -->
    </div>
  </div>
  <!-- / End Main Footer -->

  <!-- Social Footer -->
  <div class="hh-footer__social">
    <div class="hh-footer__content">
      <!-- Social Tag -->
      <p class="hh-paragraph hh-footer__social-tag">
        <span class="hh-visually-hidden">Follow us on social media:</span>
        #BeAHomeHunter
      </p>
      <!-- / End Social Tag -->

      <!-- Social Links -->
      <ul class="hh-list-unstyled hh-footer__social-link-list">
        <li>
          <a
            class="hh-footer__social-link"
            href="https://www.facebook.com/beahomehunter"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              class="svg-inline--fa fa-facebook-f"
              aria-hidden="true"
              focusable="false"
              role="img"
              viewBox="0 0 320 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M279.14 288l14.22-92.66h-88.91v-60.13c0-25.35 12.42-50.06 52.24-50.06h40.42V6.26S260.43 0 225.36 0c-73.22 0-121.08 44.38-121.08 124.72v70.62H22.89V288h81.39v224h100.17V288z"
              ></path>
            </svg>
            <span class="hh-visually-hidden">Facebook, opens a new window.</span>
          </a>
        </li>
        <li>
          <a
            class="hh-footer__social-link"
            href="https://www.instagram.com/beahomehunter/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              class="svg-inline--fa fa-instagram"
              aria-hidden="true"
              focusable="false"
              role="img"
              viewBox="0 0 448 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M224.1 141c-63.6 0-114.9 51.3-114.9 114.9s51.3 114.9 114.9 114.9S339 319.5 339 255.9 287.7 141 224.1 141zm0 189.6c-41.1 0-74.7-33.5-74.7-74.7s33.5-74.7 74.7-74.7 74.7 33.5 74.7 74.7-33.6 74.7-74.7 74.7zm146.4-194.3c0 14.9-12 26.8-26.8 26.8-14.9 0-26.8-12-26.8-26.8s12-26.8 26.8-26.8 26.8 12 26.8 26.8zm76.1 27.2c-1.7-35.9-9.9-67.7-36.2-93.9-26.2-26.2-58-34.4-93.9-36.2-37-2.1-147.9-2.1-184.9 0-35.8 1.7-67.6 9.9-93.9 36.1s-34.4 58-36.2 93.9c-2.1 37-2.1 147.9 0 184.9 1.7 35.9 9.9 67.7 36.2 93.9s58 34.4 93.9 36.2c37 2.1 147.9 2.1 184.9 0 35.9-1.7 67.7-9.9 93.9-36.2 26.2-26.2 34.4-58 36.2-93.9 2.1-37 2.1-147.8 0-184.8zM398.8 388c-7.8 19.6-22.9 34.7-42.6 42.6-29.5 11.7-99.5 9-132.1 9s-102.7 2.6-132.1-9c-19.6-7.8-34.7-22.9-42.6-42.6-11.7-29.5-9-99.5-9-132.1s-2.6-102.7 9-132.1c7.8-19.6 22.9-34.7 42.6-42.6 29.5-11.7 99.5-9 132.1-9s102.7-2.6 132.1 9c19.6 7.8 34.7 22.9 42.6 42.6 11.7 29.5 9 99.5 9 132.1s2.7 102.7-9 132.1z"
              ></path>
            </svg>
            <span class="hh-visually-hidden">Instagram, opens a new window.</span>
          </a>
        </li>
        <li>
          <a
            class="hh-footer__social-link"
            href="https://twitter.com/beahomehunter"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              class="svg-inline--fa fa-twitter"
              aria-hidden="true"
              focusable="false"
              role="img"
              viewBox="0 0 512 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M459.37 151.716c.325 4.548.325 9.097.325 13.645 0 138.72-105.583 298.558-298.558 298.558-59.452 0-114.68-17.219-161.137-47.106 8.447.974 16.568 1.299 25.34 1.299 49.055 0 94.213-16.568 130.274-44.832-46.132-.975-84.792-31.188-98.112-72.772 6.498.974 12.995 1.624 19.818 1.624 9.421 0 18.843-1.3 27.614-3.573-48.081-9.747-84.143-51.98-84.143-102.985v-1.299c13.969 7.797 30.214 12.67 47.431 13.319-28.264-18.843-46.781-51.005-46.781-87.391 0-19.492 5.197-37.36 14.294-52.954 51.655 63.675 129.3 105.258 216.365 109.807-1.624-7.797-2.599-15.918-2.599-24.04 0-57.828 46.782-104.934 104.934-104.934 30.213 0 57.502 12.67 76.67 33.137 23.715-4.548 46.456-13.32 66.599-25.34-7.798 24.366-24.366 44.833-46.132 57.827 21.117-2.273 41.584-8.122 60.426-16.243-14.292 20.791-32.161 39.308-52.628 54.253z"
              ></path>
            </svg>
            <span class="hh-visually-hidden">Twitter, opens a new window.</span>
          </a>
        </li>
        <li>
          <a
            class="hh-footer__social-link"
            href="https://www.pinterest.com/beahomehunter/"
            target="_blank"
            rel="noopener noreferrer"
          >
            <svg
              class="svg-inline--fa fa-pinterest-p"
              aria-hidden="true"
              focusable="false"
              role="img"
              viewBox="0 0 384 512"
              xmlns="http://www.w3.org/2000/svg"
            >
              <path
                fill="currentColor"
                d="M204 6.5C101.4 6.5 0 74.9 0 185.6 0 256 39.6 296 63.6 296c9.9 0 15.6-27.6 15.6-35.4 0-9.3-23.7-29.1-23.7-67.8 0-80.4 61.2-137.4 140.4-137.4 68.1 0 118.5 38.7 118.5 109.8 0 53.1-21.3 152.7-90.3 152.7-24.9 0-46.2-18-46.2-43.8 0-37.8 26.4-74.4 26.4-113.4 0-66.2-93.9-54.2-93.9 25.8 0 16.8 2.1 35.4 9.6 50.7-13.8 59.4-42 147.9-42 209.1 0 18.9 2.7 37.5 4.5 56.4 3.4 3.8 1.7 3.4 6.9 1.5 50.4-69 48.6-82.5 71.4-172.8 12.3 23.4 44.1 36 69.3 36 106.2 0 153.9-103.5 153.9-196.8C384 71.3 298.2 6.5 204 6.5z"
              ></path>
            </svg>
            <span class="hh-visually-hidden">Pinterest, opens a new window.</span>
          </a>
        </li>
      </ul>
      <!-- / End Social Links -->
    </div>
  </div>
  <!-- / End Social Footer -->

  <!-- Legal Footer -->
  <div class="hh-footer__legal">
    <div class="hh-footer__content">
      <!-- Terms / Privacy -->
      <p class="hh-paragraph">
        <a
          class="hh-footer__legal-link hh-footer__legal-link--spaced"
          [href]="companyInfo?.siteUrls?.terms?.link"
          [attr.target]="companyInfo?.siteUrls?.terms?.openInNewTab ? '_blank' : null"
          >{{ companyInfo?.siteUrls?.terms?.displayText }}</a
        >
        <a
          class="hh-footer__legal-link hh-footer__legal-link--spaced"
          [href]="companyInfo?.siteUrls?.policy?.link"
          [attr.target]="companyInfo?.siteUrls?.policy?.openInNewTab ? '_blank' : null"
          >{{ companyInfo?.siteUrls?.policy?.displayText }}</a
        >
      </p>
      <!-- / End Terms / Privacy -->

      <!-- Accessibility -->
      <p class="hh-paragraph hh-text-justify-center">
        <strong>Accessibility Promise:</strong> HomeHunt is committed to ensuring that our digital resources are as
        user-friendly as possible to all visitors. We work continuously to improve our user experience, and we encourage
        all users to provide feedback. If you have identified any issues with our website or resources, please don't
        hesitate to
        <a class="hh-footer__legal-link" [href]="'mailto:' + companyInfo?.contactEmail" rel="noopener"
          >contact&nbsp;us<span class="hh-visually-hidden">, opens an email window</span></a
        >.
      </p>
      <!-- / End Accessibility #}

      <!-- Copyright -->
      <p class="hh-paragraph hh-text-justify-center">
        Copyright &copy; {{ currentYear }} HomeHunt. All&nbsp;Rights&nbsp;Reserved.<br />
        All information provided by the listing agent/broker is deemed reliable but is not guaranteed and should be
        independently&nbsp;verified.<br />
        HomeHunt, 150 SW 12th Street #301, Fort&nbsp;Lauderdale, FL&nbsp;33316
      </p>
      <!-- / End Copyright -->

      <!-- Equal Housing Opportunity -->
      <a
        class="hh-footer__equal-housing-icon"
        href="https://www.hud.gov/fairhousing"
        target="_blank"
        rel="noopener noreferrer"
        title="Equal Housing Opportunity"
      >
        <svg
          aria-hidden="true"
          focusable="false"
          role="img"
          width="40"
          viewBox="0 0 2353.6 2249"
          xmlns="http://www.w3.org/2000/svg"
        >
          <path
            style="fill: none"
            d="M1326.3 1833.4c-19.5 0-47.1 12.1-47.1 60.6s27.6 60.6 47.1 60.6 47.2-12.1 47.2-60.6-27.6-60.6-47.2-60.6ZM220.05 2096.94h-3.7c-19.43.75-45.23 13.56-45.25 60.6v.12c0 46.93 25.91 59.84 45.25 60.6h3.7c19.34-.76 45.22-13.67 45.25-60.6v-.12c-.03-47.04-25.82-59.85-45.25-60.6ZM1082.9 2123.5c0-9.2-4-22.8-25.3-22.8h-45.1v46.5h42.5c18.9 0 28-6.5 27.9-23.7ZM429.6 2100.8h-28.8v51h33.6c27.1 0 27.1-19.3 27.1-27 0-16.9-9.4-24-31.9-24ZM404 1950l-17.5-16.3 18.6-19.5 18.4 17.1a.83.83 0 0 1 .07-.13c4.86-9 7.93-21 7.93-37.17 0-48.5-27.5-60.6-47.1-60.6-9.74 0-21.51 3-30.85 12.06s-16.25 24.23-16.25 48.54c0 48.6 27.5 60.6 47.1 60.6a41.86 41.86 0 0 0 19.6-4.6ZM735.4 1846.5l-22.3 68.6h44.3l-21.5-68.6h-.5zM830.6 2096.9c-19.6 0-47.1 12.1-47.1 60.7 0 48.5 27.5 60.7 47.1 60.7s47.1-12.2 47.1-60.7c0-48.6-27.6-60.7-47.1-60.7ZM624.7 2100.8H596v51h33.6c27 0 27-19.3 27-27 0-16.9-9.4-24-31.9-24ZM1168.05 270.33 383.6 671.2V1412h1560.3V671.2l-775.8-400.9ZM1525.4 1307.6H802V1046h723.4Zm0-375H802V671.2h723.4Z"
          />
          <path
            style="fill: #fff"
            d="M638.3 1920.1v-112.9h-37v114.3c0 21-10.1 33.1-35 33.1-16.9 0-30.9-10.6-30.9-34.8v-112.6h-37v115c.5 17.4 4.1 31.5 13.5 42 15.5 17.1 39.1 21 55.1 21 43.8.1 71.3-19.5 71.3-65.1ZM1786.6 1807.3h36.1v173.5h-36.1zM2126.2 2146.3l-35.9-75.4h-42.8l59.9 108v65.5h36.3v-65.1l58-108.4h-41.1l-34.4 75.4zM639 2070.8h-79.3v173.5H596v-62.6h41.6c46.6 0 55.3-39.7 55.3-55.4 0-33.9-20.3-55.5-53.9-55.5Zm-9.4 81H596v-51h28.7c22.5 0 31.9 7.1 31.9 24 0 7.7 0 27-27 27ZM2120.2 1832.7c25.6 0 37.9 21.8 37.9 28.6h36.2c-1.8-24-22.9-58.5-76.1-58.5-58.4-.3-84.7 44.5-84.7 91.8 0 60.9 37.9 90.8 79.7 90.8 31.7 0 45-15.7 54.1-26.3l3.6 21.7h24.1v-93.5h-72.4v29.2h40.3c-7.4 35.1-34.1 38.2-42 38.2-24.6 0-50.5-12.3-50.5-59.7 0-44.5 23.9-62.3 49.8-62.3ZM428.8 1973.7l20.6 19.6 19.1-19.6-18.9-17.8c10.6-13.6 18.2-33.4 18.2-61.9 0-81.4-60.4-91.3-83.4-91.3s-83.3 9.9-83.3 91.3 60.4 91.3 83.3 91.3c10.1 0 28-1.8 44.4-11.6Zm-91.5-79.7c0-24.31 6.91-39.47 16.25-48.54s21.11-12.06 30.85-12.06c19.6 0 47.1 12.1 47.1 60.6 0 16.22-3.07 28.18-7.93 37.17a.83.83 0 0 0-.07.13l-18.4-17.1-18.6 19.5L404 1950a41.86 41.86 0 0 1-19.6 4.6c-19.6 0-47.1-12-47.1-60.6ZM218.2 2066.3c-22.9 0-83.3 9.9-83.3 91.3s60.4 91.4 83.3 91.4 83.3-10 83.3-91.4-60.4-91.3-83.3-91.3Zm47.1 91.3v.06c0 46.93-25.91 59.84-45.25 60.6h-3.7c-19.34-.76-45.23-13.67-45.25-60.6v-.12c0-47 25.82-59.85 45.25-60.6h3.7c19.43.75 45.22 13.56 45.25 60.6v.06ZM443.8 2070.8h-79.2v173.5h36.2v-62.6h41.5c46.7 0 55.3-39.7 55.3-55.4.1-33.9-20.2-55.5-53.8-55.5Zm17.7 54c0 7.7 0 27-27.1 27h-33.6v-51h28.8c22.5 0 31.9 7.1 31.9 24ZM270.1 1838v-30.7H142.6v173.5h131.6V1950h-96.1v-44.8h84.5v-30.8h-84.5V1838h92zM1168.1 0 0 575.3v270.2h130.7v810.6h2065.9V845.5h157V575.3Zm775.8 1412H383.6V671.2l784.45-400.87 775.8 400.9ZM778.7 1980.8H818l-61-173.5h-41.8l-61.9 173.5h38.2l12-35.9h64.1Zm-65.6-65.7 22.3-68.6h.5l21.5 68.6ZM1409.7 1894c0-81.4-60.4-91.3-83.4-91.3-22.8 0-83.3 9.9-83.3 91.3s60.4 91.3 83.3 91.3 83.4-9.8 83.4-91.3Zm-83.4 60.6c-19.5 0-47.1-12.1-47.1-60.6s27.6-60.6 47.1-60.6 47.2 12.1 47.2 60.6-27.6 60.6-47.2 60.6ZM1464.3 2185.1c0 21-10.1 33.2-35 33.2-16.9 0-30.9-10.7-30.9-34.9v-112.6h-36.9v115c.4 17.4 4 31.4 13.5 42 15.5 17.1 39.2 21.2 55 21.2 43.8 0 71.3-19.7 71.3-65.4v-112.8h-37ZM1676.6 2191.6h-.4l-68.9-120.7h-38.2v173.5h33.9v-123.8h.4l70.8 123.8h36.3v-173.5h-33.9v120.7zM1582.7 1807.2h-37v114.3c0 21-10.1 33.1-35 33.1-17 0-31-10.6-31-34.8v-112.6h-36.9v115c.4 17.4 4.1 31.5 13.5 42 15.5 17.1 39.1 21 55.1 21 43.7.1 71.3-19.5 71.3-65.1ZM830.6 2066.3c-23 0-83.4 9.9-83.4 91.3s60.4 91.4 83.4 91.4 83.3-10 83.3-91.4-60.4-91.3-83.3-91.3Zm47.1 91.3c0 48.5-27.6 60.7-47.1 60.7s-47.1-12.2-47.1-60.7c0-48.6 27.5-60.7 47.1-60.7s47.1 12.1 47.1 60.7ZM1711.5 1881.9l-42.3-10.4c-7.2-1.7-18.3-4.5-18.3-18.1 0-15.7 16.4-20.8 30.2-20.8 31.7 0 34.6 18.4 35.5 26.1h34.8c-.3-21.3-14.5-56-67.7-56-56.3 0-66.7 34.1-66.7 53.4 0 38.2 27 44.4 55.1 50.9l18.6 4.4c18.3 4.3 31.4 8 31.4 21.5 0 18.4-19.1 22.5-36.3 22.5-31.6 0-36.5-18.4-36.8-28h-34.7c0 21.5 10.9 58 74.1 58 15.2 0 68.4-4.5 68.4-56.8 0-31.2-21.7-40.9-45.3-46.7ZM1776.4 2070.9h36.4v173.5h-36.4zM1114.5 2205.2c0-32.5-7.7-37.7-22-44 17.1-5.7 26.8-22.2 26.8-41.3 0-15-8.4-49.1-54.6-49.1h-87.8v173.5h35.6v-67.9h37.4c26.8 0 28.3 9.1 28.3 32.8 0 17.8 1.4 26.8 3.8 35.1h40.1v-4.7c-7.6-2.8-7.6-9.1-7.6-34.4Zm-101.9-58h-.1v-46.5h45.1c21.3 0 25.3 13.6 25.3 22.8.1 17.2-9 23.7-27.9 23.7ZM1893.8 1857h.6l70.8 123.8h36.2v-173.5h-33.8v120.8h-.6l-68.8-120.8H1860v173.5h33.8V1857zM882.6 1807.3h-36.3v173.5h122.5v-31.4h-86.2v-142.1zM1865.7 2101.6h52.3v142.8h36.2v-142.8h52.5v-30.7h-141v30.7zM1070 1807.3v173.5h36.2v-77.9h67.7v77.9h36.2v-173.5h-36.2v65.7h-67.7v-65.7H1070zM1165.7 2101.6h52.4v142.8h36.2v-142.8h52.5v-30.7h-141.1v30.7z"
          />
          <path style="fill: #fff" d="M802 671.2h723.4v261.4H802zM802 1046h723.4v261.6H802z" />
        </svg>
        <span class="hh-visually-hidden">Opens a new window.</span>
      </a>
      <!-- / End Equal Housing Opportunity -->
    </div>
  </div>
  <!-- / Legal Footer -->
</footer>
<!-- / Footer -->
